import {useRequiredConfig} from '@domain/shifthandover'
import {useWorkOrders, WorkOrder} from '@domain/work-orders'
import {EventsTab} from '@hconnect/common/types'
import {Theme, useMediaQuery} from '@mui/material'
import {getFilterDifference, Page} from '@widgets/shift-event-filters'
import {FC} from 'react'

import {useTrackShiftEventsAnalytics, usePagedData, MOBILE_ELEMENTS_PER_PAGE} from '../hooks'

import {WorkOrdersListView} from './WorkOrdersListView'

type WorkOrdersContainerProps = {
  plantId: string
  activeTab: EventsTab
  setActiveTab: (tab: EventsTab) => void
}

export const WorkOrdersContainer: FC<WorkOrdersContainerProps> = ({
  plantId,
  activeTab,
  setActiveTab
}) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const {country, shifts} = useRequiredConfig(plantId)
  const trackShiftEventAnalytics = useTrackShiftEventsAnalytics({plantId, country})

  const {
    data,
    isLoading,
    filterOptions,
    setFilters,
    changePage,
    setItemsPerPage,
    paginationOptions,
    shouldLoadNextPage
  } = usePagedData<WorkOrder>({
    plantId,
    shifts,
    fetchData: useWorkOrders,
    pageType: Page.WorkOrders
  })

  return (
    <WorkOrdersListView
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      activeFilter={filterOptions}
      events={data?.items}
      isLoading={isLoading}
      onFilterChange={(nextFilterOptions) => {
        changePage(0)
        if (isMobile) {
          setItemsPerPage(MOBILE_ELEMENTS_PER_PAGE)
        }
        setFilters(nextFilterOptions)
        trackShiftEventAnalytics({
          name: 'userAdjustsFilter',
          data: {
            filterPage: 'workOrders',
            filterName: getFilterDifference(nextFilterOptions, filterOptions)
          }
        })
      }}
      paginationOptions={isMobile ? undefined : paginationOptions}
      showBottomProgress={isMobile && shouldLoadNextPage}
      plantId={plantId}
    />
  )
}
